import { authorizedRequest } from '../../common/request';
import { profileActionTypes } from './profile-action-types';
import {applicationHistory} from './../../common/application-history';


export const profileCustomerRequest = dispatch => {
	const customerRequestUri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/profile`;

	authorizedRequest(customerRequestUri, null, 'GET', true)
		.then(customer => {
			dispatch(profileCustomerSuccess(customer));
			if(customer.acceptedTermsYn === "N") {
                applicationHistory.push("/my/account/license");
            }
		})
		.catch(error => {
			dispatch(profileCustomerFailure(error));
		});

	return {
		type: profileActionTypes.PROFILE_CUSTOMER_REQUEST
	};
};

export const profileCustomerStorage = dispatch => {
	const storageRequestUri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/stats/storage`;

	authorizedRequest(storageRequestUri)
		.then(storageInBytes => {
			dispatch(profileStorageSuccess(storageInBytes));
		})
		.catch(error => {
			dispatch(profileStorageFailure(error));
		});

	return {
		type: profileActionTypes.PROFILE_STORAGE_REQUEST
	};
};
export const profileAcceptTerms = dispatch => {
	const statsRequestUri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/profile/acceptTerms`;

	authorizedRequest(statsRequestUri,null, 'PUT')
		.then(customer => {
			dispatch(profileCustomerSuccess(customer));
			applicationHistory.push("/my/albums");
		})
		.catch(error => {
			dispatch(profileCustomerFailure(error));
		});

	return {
		type: profileActionTypes.PROFILE_STATS_REQUEST
	};
}
export const profileCustomerStats = dispatch => {
	const statsRequestUri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/stats/items`;

	authorizedRequest(statsRequestUri)
		.then(stats => {
			dispatch(profileStatsSuccess(stats));
		})
		.catch(error => {
			dispatch(profileStatsFailure(error));
		});

	return {
		type: profileActionTypes.PROFILE_STATS_REQUEST
	};
};

const profileCustomerSuccess = customer => {
	return {
		type: profileActionTypes.PROFILE_CUSTOMER_SUCCESS,
		customer: customer
	};
};

const profileCustomerFailure = error => {
	return {
		type: profileActionTypes.PROFILE_CUSTOMER_FAILURE,
		error: error
	};
};

const profileStorageSuccess = storageInBytes => {
	return {
		type: profileActionTypes.PROFILE_STORAGE_SUCCESS,
		storageInBytes: storageInBytes
	};
};

const profileStorageFailure = error => {
	return {
		type: profileActionTypes.PROFILE_STORAGE_FAILURE,
		error: error
	};
};

const profileStatsSuccess = stats => {
	return {
		type: profileActionTypes.PROFILE_STATS_SUCCESS,
		videoCount: stats.videos,
		photoCount: stats.photos
	};
};

const profileStatsFailure = error => {
	return {
		type: profileActionTypes.PROFILE_STATS_FAILURE,
		error: error
	};
};



// WEBPACK FOOTER //
// ./src/profile/actions/profile-actions.js